var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEE6",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC32F",
    fillRule: "evenodd",
    d: "M46.4 28a18.4 18.4 0 1 1-36.8 0 18.4 18.4 0 0 1 36.8 0m-16.1 9.2a2.3 2.3 0 1 1-4.6 0 2.3 2.3 0 0 1 4.6 0M28 16.5a2.3 2.3 0 0 0-2.3 2.3V28a2.3 2.3 0 1 0 4.6 0v-9.2a2.3 2.3 0 0 0-2.3-2.3",
    clipRule: "evenodd"
  })));
};
export default SvgAlert;